import { Routes } from '@angular/router';
import { AuthGuard } from 'app/Shared/Guards/auth.guard';
import { AnalyticsListComponent } from './analytics-list/analytics-list.component';
import { AnalyticCreateComponent } from './analytic-create/analytic-create.component';

export const analyticsRoutes: Routes = [
    {
        path: 'create',
        component: AnalyticCreateComponent,
        canActivate: [AuthGuard]
    },
    {
        path: 'manage',
        component: AnalyticsListComponent,
        canActivate: [AuthGuard]
    }
];
